function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M19 7.16v8.81c0 .43-.14.84-.38 1.18l-.46-.24L10 12l8.54-4.74.45-.23c.01.04.01.09.01.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.99 7.03l-.45.23L10 12l2-9 .14-.68c.29.02.58.1.85.25l5 2.85c.59.34.96.94 1 1.61z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 3l-2 9 1.85 9.23.05.3c-.38-.01-.75-.13-1.06-.36l-5-3.57c-.53-.38-.84-.98-.84-1.63V7.16c0-.72.38-1.38 1.01-1.74l5-2.85c.35-.2.74-.29 1.13-.25L12 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.62 17.15c-.13.17-.28.32-.46.45l-5 3.57c-.37.27-.82.39-1.26.36l-.05-.3L10 12l8.16 4.91.46.24z"
})));